import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { AuthenticationResult } from '@azure/msal-browser';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  errorMessage: any;

  constructor(
    private _router: Router,
    private authService: MsalService
  ) { }

  ngOnInit() {
    this.authService.handleRedirectObservable().subscribe({ 
      next: (result: AuthenticationResult) => {
        if (result != null) {
          localStorage.setItem("msal.idtoken", result.idToken);
        }
         if (this.authService.instance.getAllAccounts().length > 0) {
            this._router.navigate(['/dashboard']);
         } else {
          localStorage.clear();
          this.authService.loginRedirect();
         }
      },
      error: (error) => console.log(error)
   });
  }
}
